<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Obligaciones Periódicas Legales y de Otro Tipo</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Obligación" dense v-model="filtroobligacion">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtrotipo" :items="tipos" label="Tipo" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroalcance" :items="alcance" label="Alcance" item-text="detalle"
                                item-value="valor"></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Norma" dense v-model="filtronorma">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroaspecto" :items="aspectos" label="Aspecto"
                                item-text="detalle" item-value="valor"></v-select>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-select dense v-model="filtroresp" :items="responsables" label="Responsable"
                                item-text="detalle" item-value="valor"></v-select>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="4" sm="12">
                            MEDIO AMBIENTE: INDICADOR DE CUMPLIMIENTO MA: G9A = {{ G9A }} %
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            SST: INDICADOR DE CUMPLIMIENTO SST: G9B = {{ G9A }} %
                        </v-col>
                        <v-col cols="12" md="4" sm="12">
                            COMERCIAL: INDICADOR DE INSCRIPCIONES EN REGISTROS: G19 = {{ G19 }} %
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="400" hide-default-footer :loading="loadtable" :item-class="row_classes"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:item.ver="{ item }">

                    <v-icon small color="blue" class="mr-2" @click.stop="verInforme(item)">
                        mdi-eye
                    </v-icon>
                    <v-icon small color="blue" class="mr-2" @click.stop="editarInforme(item)">
                        mdi-pencil
                    </v-icon>
                </template>
            </v-data-table>
            <VerInforme :visible="showInforme" :codgral="editedItem.codgral" @close="showInforme = false"></VerInforme>
            <EditarInforme :visible="showEditar" :codgral="editedItem.codgral" @close="showEditar = false">
            </EditarInforme>
        </v-app>
    </div>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
import VerInforme from "../Obligaciones/Informe.vue";
import EditarInforme from "../Obligaciones/Editar.vue"
import moment from "moment";
export default {
    components: { VerInforme, EditarInforme },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroalcance: "",
        filtroresp: "",
        filtroaspecto: "",
        filtroobligacion: "",
        filtroestado: "A",
        filtronorma: "",
        filtrotipo: "",
        listado: [],
        G9A: "",
        G9B: "",
        G19: "",
        estado: [{ detalle: "Activas", valor: "A" },
        { detalle: "Inactivas", valor: "I" },
        { detalle: "Todas", valor: "" },
        ],
        tipos: [{ detalle: "Legal", valor: "L" },
        { detalle: "Registro", valor: "R" },
        { detalle: "Otro", valor: "O" },
        { detalle: "Todos", valor: "" },
        ],
        alcance: [{ detalle: "Nacional", valor: "N" },
        { detalle: "Provincial", valor: "P" },
        { detalle: "Municipal", valor: "M" },
        { detalle: "Todos", valor: "" },
        ],
        aspectos: [{ detalle: "Medio Ambiente", valor: "M" },
        { detalle: "SST", valor: "S" },
        { detalle: "Clientes y Registros", valor: "C" },
        { detalle: "Legales y Societarios", valor: "L" },
        { detalle: "Otros", valor: "O" },
        { detalle: "Todos", valor: "" },
        ],
        responsables: [{ detalle: "AGNOLON Fernando", valor: "AGNOLON Fernando" },
        { detalle: "BLANCO Sergio", valor: "BLANCO Sergio" },
        { detalle: "DEMICHELIS Leonardo", valor: "DEMICHELIS Leonardo" },
        { detalle: "GRUBESIC Monica", valor: "GRUBESIC Monica" },
        { detalle: "MANSUR Cecilia", valor: "MANSUR Cecilia" },
        { detalle: "MOLINARI Marcelo", valor: "MOLINARI Marcelo" },
        { detalle: "MONTENEGRO Sonia", valor: "MONTENEGRO Sonia" },
        { detalle: "MUSSO Marcos", valor: "MUSSO Marcos" },
        { detalle: "OFICINA DE PERSONAL", valor: "OFICINA DE PERSONAL" },
        { detalle: "PRIETO Maria Luisa", valor: "PRIETO Maria Luisa" },
        { detalle: "Todos", valor: "" },
        ],
        showInforme: false,
        showEditar: false,
        loadtable: false,
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codgral",
            },
            { text: "Obligación", value: "obligacion", sortable: false },
            { text: "Norma", value: "norma", sortable: false },
            { text: "Título", value: "titulo", sortable: false },
            { text: "Alcance", value: "alcance", align: "center", sortable: false },
            { text: "Tipo", value: "tipo", align: "center", sortable: false },
            { text: "Frecuencia", value: "frecuencia", align: "center", sortable: false },
            { text: "Fecha últ. cumplim.", align: "center", value: "fecha", sortable: false },
            { text: "Fecha prox. vencim.", align: "center", value: "fechavenc", sortable: false },
            { text: "Responsable", value: "responsable", sortable: false },
            { text: "Ver / Editar", value: "ver", align: "center", width: "5%", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                this.cargarindicadores();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        row_classes(item) {
            if (item.tramite == "ON") {
                return "purple";
            }
            if (moment(item.fechavenc, "DD/MM/YYYY") > moment() && moment(item.fechavenc, "DD/MM/YYYY") < moment().add(15, 'days')) {
                return "orange";
            }
            if (moment(item.fechavenc, "DD/MM/YYYY") > moment().add(14, 'days') && moment(item.fechavenc, "DD/MM/YYYY") < moment().add(30, 'days')) {
                return "yellow";
            }
            if ((moment(item.fechavenc, "DD/MM/YYYY") > moment().add(29, 'days'))) {
                return "green";
            }
            if (item.tramite != "ON" && (item.fechavenc == null || (moment(item.fechavenc, "DD/MM/YYYY") < moment()))) {
                return "red";
            }

        },
        getColor(estado) {
            if (
                estado == "C"
            )
                return "green";
            if (
                estado == "P"
            )
                return "red";
            if (
                estado == "N"
            )
                return "yellow";

        },
        verInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showInforme = true;
        },
        editarInforme(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },
        editarFact(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditarFact = true;
        },
        editarCierre(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditarCierre = true;
        },

        cargarindicadores() {
            let self = this;
            axios
                .get("/Sgi/IndicadoresObligaciones?")
                .then((response) => {
                    self.G9A = response.data.g9A;
                    self.G9B = response.data.g9B;
                    self.G19 = response.data.g19;
                    console.log(response.data)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        cargarListado() {
            this.loadtable = true;
            const estado = this.filtroestado;
            const alcance = this.filtroalcance;
            const aspecto = this.filtroaspecto;
            const obligacion = this.filtroobligacion;
            const resp = this.filtroresp;
            const norma = this.filtronorma;
            const tipo = this.filtrotipo;

            let self = this;
            axios
                .get("/Sgi/ListadoObligaciones?", {
                    params: {
                        estado: estado,
                        obligacion: obligacion,
                        norma: norma,
                        tipo: tipo,
                        resp: resp,
                        alcance: alcance,
                        aspecto: aspecto,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>